/**
 * Vendor Catalog Service Hooks
 * React hooks for accessing vendor catalog management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all vendor catalog-related services
 * @returns VendorCatalogServices object containing all vendor catalog service instances
 */
export function useVendorCatalogServices() {
    const { services } = useCCMS();
    if (!services?.vendorcatalog) {
        throw new Error('Vendor catalog services not available. Ensure CCMSProvider is configured with vendor catalog services.');
    }
    return services.vendorcatalog;
}
/**
 * Hook to access VendorProductService
 */
export function useVendorProductService() {
    return useVendorCatalogServices().vendorProduct;
}
/**
 * Hook to access VendorProductTypeService
 */
export function useVendorProductTypeService() {
    return useVendorCatalogServices().vendorProductType;
}
/**
 * Hook to access VendorProductStatusService
 */
export function useVendorProductStatusService() {
    return useVendorCatalogServices().vendorProductStatus;
}
/**
 * Hook to access VendorProductMediaTypeService
 */
export function useVendorProductMediaTypeService() {
    return useVendorCatalogServices().vendorProductMediaType;
}
/**
 * Hook to access VendorProductCategoryService
 */
export function useVendorProductCategoryService() {
    return useVendorCatalogServices().vendorProductCategory;
}
/**
 * Hook to access VendorProductVariantService
 */
export function useVendorProductVariantService() {
    return useVendorCatalogServices().vendorProductVariant;
}
/**
 * Hook to access VendorProductMediaService
 */
export function useVendorProductMediaService() {
    return useVendorCatalogServices().vendorProductMedia;
}
/**
 * Hook to access VendorProductRuleService
 */
export function useVendorProductRuleService() {
    return useVendorCatalogServices().vendorProductRule;
}
/**
 * Hook to access VendorProductAnalyticService
 */
export function useVendorProductAnalyticService() {
    return useVendorCatalogServices().vendorProductAnalytic;
}
/**
 * Hook to access VendorProductEventLimitService
 */
export function useVendorProductEventLimitService() {
    return useVendorCatalogServices().vendorProductEventLimit;
}
/**
 * Hook to access VendorProductLogService
 */
export function useVendorProductLogService() {
    return useVendorCatalogServices().vendorProductLog;
}
/**
 * Hook to access VendorCatalogShopService
 */
export function useVendorCatalogShopService() {
    return useVendorCatalogServices().vendorCatalogShop;
}
/**
 * Hook to access VendorProductAddOnService
 */
export function useVendorProductAddOnService() {
    return useVendorCatalogServices().vendorProductAddOn;
}
/**
 * Hook to access VendorProductAddOnCategoryService
 */
export function useVendorProductAddOnCategoryService() {
    return useVendorCatalogServices().vendorProductAddOnCategory;
}
/**
 * Hook to access VendorProductVariantCategoryService
 */
export function useVendorProductVariantCategoryService() {
    return useVendorCatalogServices().vendorProductVariantCategory;
}
/**
 * Hook to access StockShopService (public stock status, cart validation, interest tracking)
 */
export function useStockShopService() {
    return useVendorCatalogServices().stockShop;
}
/**
 * Hook to access StockPortalService (vendor stock management)
 */
export function useStockPortalService() {
    return useVendorCatalogServices().stockPortal;
}
//# sourceMappingURL=useVendorCatalogServices.js.map